/* eslint-disable */
import React, { useState, useRef, useCallback } from "react";
import { getUtilityBillPayments, payUtilityBill, uploadReceipt, markUtilityBillAsPaid, uploadUtilityBillReceipt, runUtilityBillsBot } from "../../../actions";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";
import Inputs from "../../Inputs";
import ModalComponent from "../../ModalComponent/ModalComponent";
import PayEpayUtilityBillModal from "../../ModalComponent/PayEpayUtilityBillModal";
import RunBotConfirmModal from "../../ModalComponent/RunBotConfirmModal";
import "./styles.scss";

const MAX_BOT_BILLS = 20;

const formatAmounts = (amounts) => {
  if (!amounts.length) {
    return "0.00 €";
  }
  return amounts
    .map(({ amount, currency }) => `${Number(amount).toFixed(2)} ${currency === "eur" ? "€" : currency.toUpperCase()}`)
    .join(" + ");
};

// Only bills charged by Stripe whose Epay payment failed can go to the bot
const isBotPayable = (bill) => bill.stripeStatus === "paid" && bill.epayStatus === "failed";

const UtilityBills = ({
  getUtilityBillPayments,
  payUtilityBill,
  uploadReceipt,
  utilityBills,
  period,
  markUtilityBillAsPaid, // NEW: Add the new action
  uploadUtilityBillReceipt, // NEW: Add the new action
  runUtilityBillsBot,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selBill, setSelBill] = useState("");
  const [selectedBillReceiptUrl, setSelectedBillReceiptUrl] = useState(null);
  const [selectedBillStatus, setSelectedBillStatus] = useState(null); // NEW
  const [selectedBillReceiptNote, setSelectedBillReceiptNote] = useState(null); // NEW
  const [modalMode, setModalMode] = useState("pay");
  const [selectedIds, setSelectedIds] = useState([]);
  const [botSelectMode, setBotSelectMode] = useState(false);
  const [botConfirmOpen, setBotConfirmOpen] = useState(false);
  const [botRunning, setBotRunning] = useState(false);
  const lastFetchPayloadRef = useRef({});

  const fetchUtilityBills = useCallback((payload = {}) => {
    const { onSuccess, onError, ...query } = payload;
    lastFetchPayloadRef.current = query;
    if ((payload.page || 1) === 1) {
      setSelectedIds([]);
    }
    getUtilityBillPayments(payload);
  }, [getUtilityBillPayments]);

  const refetchFirstPage = () => {
    fetchUtilityBills({ ...lastFetchPayloadRef.current, page: 1 });
  };

  // Custom action handler for the Pay button
  const handlePayClick = (billId, status) => {
    console.log("💰 Properties handlePayClick called with:", billId, status);
    
    // Find the bill to get its receipt URL, status, and receipt note
    const bill = utilityBills?.docs?.find(b => b._id === billId);
    const receiptUrl = bill?.receiptUrl || null;
    const paymentStatus = bill?.epayStatus || status; // Use epayStatus from API
    const receiptNote = bill?.receiptNote || bill?.receiptUrl || null; // Get receipt note
    
    console.log("📋 Bill details:", { billId, paymentStatus, receiptUrl, receiptNote });
    
    setOpenModal(true);
    setSelBill(billId);
    setSelectedBillReceiptUrl(receiptUrl);
    setSelectedBillStatus(paymentStatus);
    setSelectedBillReceiptNote(receiptNote);
  };

  const handleUploadInvoiceClick = (billId) => {
    const bill = utilityBills?.docs?.find(b => b._id === billId);

    setOpenModal(true);
    setSelBill(billId);
    setSelectedBillReceiptUrl(null);
    setSelectedBillStatus(bill?.epayStatus || null);
    setSelectedBillReceiptNote(null);
    setModalMode("upload-invoice");
  };

  // Handle modal close
  const handleModalClose = () => {
    setOpenModal(false);
    setSelBill("");
    setSelectedBillReceiptUrl(null);
    setSelectedBillStatus(null);
    setSelectedBillReceiptNote(null);
    setModalMode("pay");
  };

  // Handle payment confirmation - NEW: Backend-compliant logic
  const handlePaymentConfirm = ({ billId, action, receiptFile, useExistingReceipt, paymentStatus, requiredAction }) => {
    console.log("💰 Payment confirmed:", { billId, action, receiptFile, useExistingReceipt, paymentStatus, requiredAction });
    
    if (action === "mark-as-paid") {
      // Use mark-as-paid endpoint for failed payments
      const payload = {
        billId: billId,
        receiptFile: receiptFile,
        onSuccess: (response) => {
          refetchFirstPage();
        },
        onError: (error) => {
          console.error("❌ Mark as paid failed:", error);
        }
      };
      markUtilityBillAsPaid(payload);
      
    } else if (action === "upload-receipt") {
      // Use upload-receipt endpoint for paid payments
      const payload = {
        billId: billId,
        receiptFile: receiptFile,
        useExistingReceipt: useExistingReceipt,
        onSuccess: (response) => {
          refetchFirstPage();
        },
        onError: (error) => {
          console.error("❌ Upload receipt failed:", error);
        }
      };
      uploadUtilityBillReceipt(payload);
    }
    
    // Close modal
    handleModalClose();
  };

  const failedStats = utilityBills?.stats?.failed;
  const failedAmount = formatAmounts(failedStats?.amounts || []);

  const selectedBills = (utilityBills?.docs || []).filter((bill) => selectedIds.includes(bill._id));
  const selectedAmount = formatAmounts(
    Object.entries(
      selectedBills.reduce((acc, bill) => {
        const currency = bill.currency || "eur";
        acc[currency] = (acc[currency] || 0) + (bill.price || 0);
        return acc;
      }, {})
    ).map(([currency, amount]) => ({ currency, amount }))
  );
  const tooManySelected = selectedIds.length > MAX_BOT_BILLS;

  const cancelBotSelection = () => {
    setBotSelectMode(false);
    setSelectedIds([]);
  };

  const handleRunBot = () => {
    setBotRunning(true);
    runUtilityBillsBot({
      ids: selectedIds,
      onSuccess: () => {
        setBotRunning(false);
        setBotConfirmOpen(false);
        setBotSelectMode(false);
        refetchFirstPage();
      },
      onError: () => {
        setBotRunning(false);
      },
    });
  };

  // Enhance the data with action handlers
  const enhancedData = {
    ...utilityBills,
    docs: utilityBills?.docs?.map(bill => ({
      ...bill,
      onPayClick: handlePayClick,
      onUploadInvoiceClick: handleUploadInvoiceClick
    }))
  };

  return (
    <>
      <DataTable
        {...tablePresets.utilityBills}
        features={{ ...tablePresets.utilityBills.features, rowSelection: botSelectMode }}
        className="utility-bills-table"
        data={enhancedData}
        fetchData={fetchUtilityBills}
        period={period}
        selectedRowKeys={selectedIds}
        onSelectionChange={setSelectedIds}
        isRowSelectable={isBotPayable}
      />
      {failedStats && (
        <div className={`utility-bills-summary ${failedStats.count ? "" : "empty"}`}>
          <div className="summary-item">
            <div className="indicator failed" />
            <b>{failedStats.count}</b>
            <span>{failedStats.count === 1 ? "unpaid bill" : "unpaid bills"} -</span>
            <b>{failedAmount}</b>
          </div>
          {botSelectMode ? (
            <>
              <button
                className="run-bot-button"
                disabled={!selectedIds.length || tooManySelected || botRunning}
                onClick={() => setBotConfirmOpen(true)}
              >
                Confirm{selectedIds.length ? ` (${selectedIds.length})` : ""}
              </button>
              <button className="run-bot-button secondary" disabled={botRunning} onClick={cancelBotSelection}>
                Cancel
              </button>
              <span className={`run-bot-hint ${tooManySelected ? "error" : ""}`}>
                {tooManySelected ? `Select up to ${MAX_BOT_BILLS} bills at a time` : "Select the bills to pay"}
              </span>
            </>
          ) : (
            <button className="run-bot-button" disabled={!failedStats.count} onClick={() => setBotSelectMode(true)}>
              Force bot payment
            </button>
          )}
        </div>
      )}
      <RunBotConfirmModal
        isOpen={botConfirmOpen}
        bills={selectedBills}
        totalAmount={selectedAmount}
        loading={botRunning}
        onConfirm={handleRunBot}
        onClose={() => setBotConfirmOpen(false)}
      />
      <PayEpayUtilityBillModal
        isOpen={openModal}
        onClose={handleModalClose}
        onConfirm={handlePaymentConfirm}
        billId={selBill}
        existingReceiptUrl={selectedBillReceiptUrl}
        paymentStatus={selectedBillStatus}
        existingReceiptNote={selectedBillReceiptNote}
        mode={modalMode}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  console.log("🗃️ UtilityBills mapStateToProps - appProperties:", state.appProperties);
  return {
    utilityBills: state.appProperties?.utilityBillPayments || { docs: [], totalPages: 0 },
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUtilityBillPayments: (payload) => dispatch(getUtilityBillPayments(payload)),
  payUtilityBill: (payload) => dispatch(payUtilityBill(payload)),
  uploadReceipt: (payload) => dispatch(uploadReceipt(payload)),
  markUtilityBillAsPaid: (payload) => dispatch(markUtilityBillAsPaid(payload)),
  uploadUtilityBillReceipt: (payload) => dispatch(uploadUtilityBillReceipt(payload)),
  runUtilityBillsBot: (payload) => dispatch(runUtilityBillsBot(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UtilityBills);